/**
 * Elite Prime tab back intercept — confirm before leaving the sell landing.
 *
 * Belongs here: Prime Assistant WhatsApp CTA + Go back (only path that pops).
 * Does not belong here: Elite-tab back (pops immediately from the header).
 */
import { getBottomPadding } from '../../../utils/sessionStorage'
import { goBack, openWhatsapp } from '../../../utils/appBridge'
import { ElitePlansEventId, trackElitePlansClick } from '../analytics'
import {
  PRIME_ASSISTANT_ICON_SRC,
  PRIME_ASSISTANT_WHATSAPP_CALLBACK_URL,
} from '../constants/primeAssistant'

const WHATSAPP_ICON_SRC = '/images/elite-plans/elite-prime/back-sheet/whatsapp.svg'

type ElitePrimeBackConfirmBottomSheetProps = {
  titleId: string
  onClose: () => void
}

export function ElitePrimeBackConfirmBottomSheet({
  titleId,
  onClose
}: ElitePrimeBackConfirmBottomSheetProps) {
  const handleChatWithPrimeAssistant = () => {
    trackElitePlansClick(ElitePlansEventId.CtaClick, {
      planId: 'elite-prime',
      buttonLabel: 'Chat with Prime Assistant'
    })
    openWhatsapp(PRIME_ASSISTANT_WHATSAPP_CALLBACK_URL)
  }

  const handleGoBack = () => {
    trackElitePlansClick(ElitePlansEventId.Back, {
      planId: 'elite-prime',
      buttonLabel: 'Go back_btn'
    })
    onClose()
    goBack()
  }

  return (
    <div
      className='bg-white text-left'
      style={{ paddingBottom: `calc(${getBottomPadding()}px + 20px)` }}
    >
      <div className='px-5 pt-7'>
        <img
          src={PRIME_ASSISTANT_ICON_SRC}
          alt=''
          width={68}
          height={68}
          className='size-[68px] object-contain'
        />
        <h2
          id={titleId}
          tabIndex={-1}
          className='mt-4 max-w-[289px] text-[22px] font-medium leading-[1.2] text-[#232323] outline-none'
        >
          Have any questions?
        </h2>
        <p className='mt-3 max-w-[319px] text-base font-normal leading-[1.5] text-[#6a6e6e]'>

          Request a callback and a <span className='font-medium text-[#b85230]'>Prime Expert</span> will get back to you shortly. Available on weekdays, 10am–8pm
        </p>
      </div>

      <div className='mt-6 flex flex-col gap-4 px-5'>
        <button
          type='button'
          onClick={handleChatWithPrimeAssistant}
          className='ep-focus-ring flex min-h-[56px] w-full items-center justify-center gap-2 rounded-xl border-none bg-[#232323] px-6 text-base font-medium text-white'
        >
          <img
            src={WHATSAPP_ICON_SRC}
            alt=''
            aria-hidden='true'
            width={20}
            height={20}
            className='size-5 shrink-0'
          />
          Request a callback
        </button>
        <button
          type='button'
          onClick={handleGoBack}
          className='ep-focus-ring flex min-h-[56px] w-full items-center justify-center rounded-xl border-none bg-[#f0f4f7] px-6 text-base font-medium text-[#232323]'
        >
          Go back
        </button>
      </div>
    </div>
  )
}
